// Small helpers shared across the benefits tab subcomponents.

export const humanCategory = (s) => {
  if (!s) return "";
  return s
    .toString()
    .split(/[_\s-]+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

export const humanEnum = humanCategory;

export const formatPercent = (ratio) => {
  if (ratio === null || ratio === undefined || Number.isNaN(ratio)) return "—";
  return `${(ratio * 100).toFixed(1)}%`;
};

export const benefitStatusBadgeVariant = (status) => {
  switch (status) {
    case "active":
      return "success";
    case "draft":
      return "secondary";
    case "archived":
      return "outline";
    default:
      return "outline";
  }
};

export const extractApiError = (err, fallback = "Something went wrong.") =>
  err?.response?.data?.message ||
  err?.response?.data?.error ||
  err?.message ||
  fallback;
